// extracted by mini-css-extract-plugin
module.exports = {"container":"Input_container__zw9g5","input-wrapper":"Input_input-wrapper__KOnoI","input":"Input_input__WO0Tr","label":"Input_label__8QOmb","box-shadow":"Input_box-shadow__vI7zH"};